export enum DateFormatEnum {
  ddMMyyyy = 'dd-MM-yyyy',
  DDMMMYYYY = 'DD MMM YYYY',
  ddMMM = 'dd MMM',
  ddMMyyyEN = 'dd/MM/yyyy',
  textMonth = 'dd MMM yyyy',
  yyyyMMdd = 'yyyy-MM-dd',
  time24h = 'HH:mm',
  textMonthWithTime = 'dd MMM yyyy HH:mm',
  PDFdMMMyyyy = 'd MMM yyyy',
  PDFdMMMyyyyHHmm = 'd MMM yyyy HH:mm',
}

export type DateFormatEnumType = keyof typeof DateFormatEnum;
